var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCurrentUserFetched),expression:"isCurrentUserFetched"}],class:_vm.$style.auth},[_c('client-only',[_c('Login')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }